import Axios, { AxiosError, AxiosResponse } from 'axios';
import { Url } from '../general/modules/url';
import { HubApiRequestError } from './HubApiRequestError';
import { HubApiNetworkError } from './HubApiNetworkError';
import { JRpcResponse } from '../general/modules/jsonRpc/jsonRpcResponseFactory';
import { CustomJrpcErrResult } from '../general/modules/jsonRpc/jRpcErrResponse';

type JsonRpcRequest<T> = {
    jsonrpc: '2.0',
    method: string,
    deviceIdentifier? : string
    params: [T]
};

export class HubJsonRpcRequest {
    public static async makeRequest<Response, Request>(method: string, data: Request, deviceIdentifier: string = null)
        : Promise<Response | CustomJrpcErrResult> {
        const url = Url.getHubClientRestapiUrl();
        const request: JsonRpcRequest<Request> = {
            jsonrpc: '2.0',
            method: method,
            deviceIdentifier: deviceIdentifier,
            params: [{ ...data }]
        };
        return Axios.post(url, request, {
            headers: {}
        })
            .then((response: AxiosResponse<JRpcResponse<Response|CustomJrpcErrResult>>)=>{
                const data = response.data;

                if ('error' in data) {
                    throw new HubApiRequestError(data.error.message);
                }

                return data.result;
            })
            .catch((error: AxiosError) => {
                throw new HubApiNetworkError(`Hub request finished with code ${error.response.status}`);
            });
    }
}
